module.exports = __webpack_public_path__ + "img/heart-icon-jst.07fd640b.png";